{
  "dashboard": {
    "title": "Администраторско табло",
    "loading": "Зареждане...",
    "welcomeBack": "Добре дошли отново, {{name}}. Ето вашия преглед на платформата.",
    "platformOverview": "Преглед на платформата — управлявайте наематели, потребители и здравето на системата с един поглед.",
    "refresh": "Обновяване",
    "aiSettings": "AI настройки",
    "servicesUnreachable": "Някои услуги са недостъпни",
    "failedClients": "Неуспешно зареждане на данните за клиенти.",
    "failedUsers": "Неуспешно зареждане на данните за потребители.",
    "retry": "Опитай отново",
    "stats": {
      "clients": "Клиенти",
      "companies": "Компании",
      "users": "Потребители",
      "modules": "Модули"
    },
    "quickActions": {
      "title": "Бързи действия",
      "manageClients": "Управление на клиенти",
      "manageClientsDesc": "Преглед и управление на клиентски акаунти",
      "userManagement": "Управление на потребители",
      "userManagementDesc": "Преглед на потребители и техните роли",
      "aiSettings": "AI настройки",
      "aiSettingsDesc": "Глобална AI конфигурация",
      "aiLogs": "AI логове",
      "aiLogsDesc": "Преглед на AI операционни логове"
    },
    "systemHealth": {
      "title": "Здраве на системата",
      "allOperational": "Всичко работи",
      "issuesDetected": "Открити проблеми",
      "authService": "Auth услуга",
      "userDirectory": "Потребителски каталог",
      "tenantRegistry": "Регистър на наематели",
      "moduleRegistry": "Регистър на модули",
      "operational": "Работи",
      "apiUnreachable": "API недостъпно",
      "cannotFetchUsers": "Потребителите не могат да бъдат заредени",
      "cannotFetchClients": "Клиентите не могат да бъдат заредени",
      "registered": "{{count}} регистрирани",
      "clients": "{{count}} клиенти"
    },
    "recentClients": "Последни клиенти",
    "recentUsers": "Последни потребители",
    "viewAll": "Виж всички ({{count}})",
    "userRoleDistribution": "Разпределение на потребителски роли",
    "topClientsByCompanies": "Топ клиенти по компании",
    "registeredModules": "Регистрирани модули",
    "noUserData": "Няма налични потребителски данни",
    "noClientData": "Няма налични клиентски данни",
    "failedLoadClients": "Неуспешно зареждане на клиенти",
    "noClientsYet": "Все още няма клиенти",
    "failedLoadUsers": "Неуспешно зареждане на потребители",
    "noUsersYet": "Все още няма потребители",
    "company": "компания",
    "companies": "компании",
    "table": {
      "client": "Клиент",
      "companies": "Компании",
      "created": "Създаден",
      "user": "Потребител",
      "role": "Роля",
      "memberships": "Членства",
      "clientCount": "{{count}} клиент(и)",
      "companyCount": "{{count}} компания(и)",
      "tenantCount": "{{count}} наемател",
      "tenantCount_plural": "{{count}} наематели"
    }
  },
  "ai": {
    "general": {
      "title": "AI основни настройки",
      "subtitle": "Конфигуриране на глобални AI настройки и системни параметри.",
      "totalRequests": "Общо заявки",
      "successRate": "Процент на успех",
      "avgResponseTime": "Средно време за отговор",
      "activeModels": "Активни модели",
      "tabs": {
        "api": "API конфигурация",
        "performance": "Производителност",
        "monitoring": "Мониторинг",
        "security": "Сигурност"
      },
      "fields": {
        "modelProvider": "Доставчик на модел",
        "modelProviderRequired": "Моля, изберете доставчик на модел",
        "modelProviderPlaceholder": "Изберете доставчик на модел",
        "apiKey": "API ключ",
        "apiKeyRequired": "Моля, въведете API ключ",
        "apiKeyPlaceholder": "Въведете API ключ",
        "maxTokens": "Максимални токени",
        "maxTokensRequired": "Моля, въведете максимални токени",
        "maxTokensPlaceholder": "Максимални токени на заявка",
        "temperature": "Температура",
        "temperatureRequired": "Моля, въведете температура",
        "temperaturePlaceholder": "Температура на модела (0-2)",
        "requestTimeout": "Таймаут на заявката (секунди)",
        "timeoutRequired": "Моля, въведете таймаут",
        "timeoutPlaceholder": "Таймаут на заявката в секунди",
        "retryAttempts": "Брой повторни опити",
        "retryAttemptsRequired": "Моля, въведете брой повторни опити",
        "retryAttemptsPlaceholder": "Брой повторни опити",
        "enableCaching": "Активиране на кеширане на отговори",
        "cacheExpiry": "Изтичане на кеш (секунди)",
        "cacheExpiryRequired": "Моля, въведете изтичане на кеш",
        "cacheExpiryPlaceholder": "Изтичане на кеш в секунди",
        "enableRateLimit": "Активиране на ограничение на заявки",
        "rateLimit": "Ограничение на заявки (на минута)",
        "rateLimitRequired": "Моля, въведете ограничение на заявки",
        "rateLimitPlaceholder": "Заявки на минута",
        "enableLogging": "Активиране на AI логване",
        "enableMonitoring": "Активиране на мониторинг на производителността",
        "alertThreshold": "Праг за аларма (%)",
        "alertThresholdRequired": "Моля, въведете праг за аларма",
        "alertThresholdPlaceholder": "Праг за аларма в проценти",
        "logAllRequests": "Логване на всички AI заявки",
        "enableEncryption": "Активиране на криптиране на заявки",
        "enableIpWhitelist": "Активиране на IP бял списък"
      },
      "security": {
        "title": "Настройки за сигурност",
        "description": "Конфигуриране на параметри за сигурност за достъп до AI модели и защита на данни."
      },
      "saveNotice": "Промените ще влязат в сила след запазване и рестартиране на AI услугата.",
      "reset": "Нулиране",
      "saveSettings": "Запази настройките",
      "settingsSaved": "Настройките са запазени успешно",
      "checkInput": "Моля, проверете въведените данни",
      "settingsReset": "Настройките са нулирани до стойностите по подразбиране"
    },
    "logs": {
      "title": "Логове на платформата",
      "subtitle": "Изпълнения на флоуове във всички тенанти и журнал на промените по флоуове и шаблони."
    }
  },
  "tenants": {
    "title": "Управление на наематели",
    "subtitle": "Управление на акаунти на наематели и свързаните с тях компании. Създаване, конфигуриране и мониторинг на достъпа на наематели в платформата.",
    "clients": "Наематели",
    "addClient": "Добави наемател",
    "paginationTotal": "{{start}}-{{end}} от {{total}} наематели",
    "search": "Търсене",
    "searchPlaceholder": "Търсене по име на наемател",
    "searchPending": "Търсене…",
    "searchResults": "{{count}} наематели за \"{{query}}\"",
    "noSearchResults": "Няма наематели за \"{{query}}\"",
    "clearFilters": "Изчисти филтрите",
    "columns": {
      "client": "Наемател",
      "companies": "Компании",
      "status": "Статус",
      "createdAt": "Създаден",
      "lastUpdated": "Последна актуализация",
      "actions": "Действия"
    },
    "active": "Активен",
    "created": "Създаден {{time}}",
    "manageClient": "Управление на наемател",
    "manageClientTooltip": "Управление на настройките на наемателя",
    "moduleManagement": "Управление на модули",
    "moduleManagementTooltip": "Конфигуриране на модули",
    "editClient": "Редактиране на наемател",
    "addNewClient": "Добавяне на наемател",
    "saveChanges": "Запази промените",
    "createClient": "Създай наемател",
    "cancel": "Отказ",
    "form": {
      "clientName": "Име на наемател",
      "clientNameRequired": "Моля, въведете име на наемател.",
      "clientNameMin": "Името на наемателя трябва да е поне 2 символа.",
      "clientNameDuplicate": "Вече съществува наемател с това име.",
      "clientNameTooltip": "Показваното име за този наемател",
      "clientNamePlaceholder": "напр. Acme Corporation",
      "clientKey": "Ключ на наемател",
      "clientKeyRequired": "Моля, въведете ключ на наемател.",
      "clientKeyPattern": "Ключът трябва да съдържа само малки букви, цифри и тирета.",
      "clientKeyDuplicate": "Вече съществува наемател с този ключ.",
      "clientKeyTooltip": "Уникален идентификатор за API заявки (малки букви, буквено-цифрови, тирета)",
      "clientKeyPlaceholder": "напр. acme-corp"
    },
    "messages": {
      "updateNotImplemented": "Функцията за актуализация на наемател все още не е имплементирана",
      "createSuccess": "Наемателят е създаден успешно",
      "createError": "Неуспешно създаване на наемател: {{error}}",
      "deleteNotImplemented": "Функцията за изтриване на наемател все още не е имплементирана"
    },
    "detail": {
      "backToClients": "Обратно към наематели",
      "clientDetails": "Детайли за наемател",
      "clientDetailsSubtitle": "Детайли и информация за наемател",
      "errorLoading": "Грешка при зареждане на наемател: {{error}}",
      "clientNotFound": "Наемателят не е намерен.",
      "viewLogs": "Преглед на логове",
      "editClient": "Редактиране на наемател",
      "deleteClient": "Изтриване на наемател",
      "clientInformation": "Информация за наемател",
      "generateRegistrationLink": "Генериране на линк за регистрация",
      "clientName": "Име на наемател",
      "clientKey": "Ключ на наемател",
      "clientId": "ID на наемател",
      "createdAt": "Създаден на",
      "lastUpdated": "Последна актуализация",
      "status": "Статус",
      "active": "Активен",
      "companies": "Компании",
      "addCompany": "Добави компания",
      "totalCompanies": "Общо компании",
      "edit": "Редактирай",
      "generateLink": "Генерирай линк",
      "noCompanies": "Няма компании, свързани с този наемател",
      "clientOwners": "Собственици на наемател",
      "clientEmployees": "Служители на наемател",
      "clientCustomers": "Клиенти на наемателя",
      "noOwnersFound": "Няма намерени собственици",
      "noEmployeesFound": "Няма намерени служители",
      "noCustomersFound": "Няма намерени клиенти",
      "paginationOwners": "{{start}}-{{end}} от {{total}} собственици",
      "paginationEmployees": "{{start}}-{{end}} от {{total}} служители",
      "paginationCustomers": "{{start}}-{{end}} от {{total}} клиенти",
      "table": {
        "user": "Потребител",
        "status": "Статус",
        "role": "Роля",
        "joined": "Присъединен",
        "companies": "Компании",
        "companyName": "Компания",
        "domain": "Домен",
        "city": "Град",
        "country": "Държава",
        "email": "Имейл",
        "actions": "Действия"
      },
      "generateInviteLink": "Генериране на линк за покана",
      "addMember": {
        "title": "Добавяне на член",
        "description": "Добавете потребител към наемател {{name}} с роля на ниво клиент.",
        "button": "Добави член",
        "selectUser": "Потребител",
        "selectUserRequired": "Моля, изберете потребител",
        "selectUserPlaceholder": "Изберете потребител",
        "role": "Роля",
        "roleOwner": "Собственик",
        "roleEmployee": "Служител",
        "add": "Добави член",
        "cancel": "Отказ",
        "memberAdded": "Членът е добавен успешно",
        "addError": "Неуспешно добавяне: {{error}}",
        "noUsersAvailable": "Няма налични потребители за добавяне"
      },
      "addToCompany": {
        "title": "Добавяне към компания",
        "description": "Добавете член на клиента към {{company}}.",
        "descriptionAny": "Добавете член на клиента към компания.",
        "short": "Добави към компания",
        "selectUser": "Член на клиента",
        "selectUserRequired": "Моля, изберете потребител",
        "selectUserPlaceholder": "Изберете потребител",
        "selectCompany": "Компания",
        "selectCompanyRequired": "Моля, изберете компания",
        "selectCompanyPlaceholder": "Изберете компания",
        "role": "Роля",
        "roleOwner": "Собственик",
        "roleEmployee": "Служител",
        "add": "Добави към компания",
        "cancel": "Отказ",
        "added": "Успешно добавен към компанията",
        "error": "Грешка при добавяне: {{error}}",
        "noMembers": "Няма членове на клиента за добавяне"
      },
      "removeFromCompany": {
        "confirmTitle": "Премахване от компанията?",
        "confirmDesc": "Потребителят няма да бъде член на тази компания.",
        "ok": "Премахни",
        "cancel": "Отказ"
      },
      "removeFromTenant": {
        "confirmTitle": "Премахване от наемателя?",
        "confirmDesc": "Потребителят ще загуби достъп до този наемател.",
        "button": "Премахни",
        "ok": "Премахни",
        "cancel": "Отказ"
      },
      "deleteCompany": {
        "confirmTitle": "Изтриване на компанията?",
        "confirmDesc": "Всички членове ще бъдат премахнати от тази компания. Действието не може да бъде отменено.",
        "ok": "Изтрий",
        "cancel": "Отказ",
        "tooltip": "Изтрий компания",
        "success": "Компанията е изтрита",
        "error": "Неуспешно изтриване на компанията"
      },
      "activeStatus": "Активен",
      "inactiveStatus": "Неактивен",
      "emailVerified": "Имейл потвърден",
      "emailUnverified": "Имейл непотвърден",
      "phoneVerified": "Телефон потвърден",
      "phoneUnverified": "Телефон непотвърден",
      "token": {
        "title": "Генериране на линк за регистрация",
        "generatingForClient": "Генериране на линк за регистрация за наемател: {{name}}",
        "generatingForCompany": "Генериране на линк за регистрация за компания: {{name}}",
        "selectRoleDescription": "Изберете роля на наемател за линка за регистрация. Потребителите, които се регистрират с този линк, ще получат избраната роля.",
        "tenantRole": "Роля на наемател",
        "tenantRoleRequired": "Моля, изберете роля на наемател",
        "tenantRolePlaceholder": "Изберете роля на наемател",
        "tenantRoleTooltip": "Изберете ролята, която ще бъде присвоена на потребителите, регистриращи се чрез този линк",
        "roleOwner": "Собственик",
        "roleAdmin": "Администратор",
        "roleEmployee": "Служител",
        "generateLink": "Генерирай линк",
        "close": "Затвори",
        "cancel": "Отказ",
        "successTitle": "Линкът за регистрация е генериран успешно",
        "successDescription": "Този линк за регистрация може да се използва за покана на потребители към този наемател с посочената роля. Споделете го по сигурен начин.",
        "linkDetails": "Детайли на линка",
        "tenantRoleLabel": "Роля на наемател",
        "clientIdLabel": "ID на наемател",
        "companyIdLabel": "ID на компания",
        "expiresAt": "Изтича на",
        "registrationUrl": "URL за регистрация",
        "registrationLink": "Линк за регистрация:",
        "copyRegistrationLink": "Копирай линк за регистрация",
        "securityNotice": "Забележка за сигурност",
        "securityDescription": "Този URL за регистрация ще бъде показан само веднъж. Уверете се, че сте го копирали, преди да затворите този диалог. Всеки с този URL може да се регистрира и да се присъедини към наемателя с посочената роля.",
        "tokenSuccess": "Токенът е издаден успешно",
        "tokenError": "Неуспешно издаване на токен: {{error}}",
        "copySuccess": "URL за регистрация е копиран в клипборда!"
      },
      "messages": {
        "editNotImplemented": "Функцията за редактиране на наемател все още не е имплементирана",
        "deleteNotImplemented": "Функцията за изтриване на наемател все още не е имплементирана",
        "companyCreated": "Компанията е създадена успешно",
        "companyCreateError": "Неуспешно създаване на компания: {{error}}",
        "companyUpdated": "Компанията е актуализирана успешно",
        "companyUpdateError": "Неуспешна актуализация на компания: {{error}}"
      },
      "addCustomer": {
        "title": "Добавяне на клиент",
        "description": "Дайте на съществуващ потребител клиентски достъп до тенант {{name}}.",
        "add": "Добави клиент",
        "memberAdded": "Клиентът е добавен",
        "addError": "Неуспешно добавяне на клиент: {{error}}"
      },
      "customers": {
        "title": "Клиенти",
        "search": "Търсене по име, имейл или телефон",
        "invite": "Покани клиент",
        "add": "Добави клиент",
        "removed": "Клиентът е премахнат от тенанта",
        "removeError": "Неуспешно премахване на клиента"
      },
      "eventTriggers": {
        "title": "Тригери за събития",
        "subtitle": "Свържете събития от домейна с потоци за този клиент.",
        "eventType": "Тип събитие",
        "flow": "Поток",
        "triggerNode": "Тригер възел",
        "active": "Активен",
        "addMapping": "Добави връзка",
        "addMappingTooltip": "Свържете събитие от домейна с тригер на поток",
        "add": "Създай връзка",
        "cancel": "Отказ",
        "delete": "Изтрий",
        "allEvents": "Всички събития",
        "allFlows": "Всички потоци",
        "allNodes": "Всички възли",
        "clearFilters": "Изчисти филтрите",
        "showingCount": "Показани {{count}} от {{total}} връзки",
        "empty": "Все още няма връзки за събития",
        "emptyHint": "Събития като създаване на час или регистрация на потребител могат да стартират автоматизации.",
        "deleteTooltip": "Изтрий тази връзка",
        "deleteConfirm": "Изтриване на тази връзка?",
        "deleteConfirmDescription": "Връзката за събитието ще бъде премахната. Можете да я добавите отново по-късно.",
        "selectEvent": "Изберете събитие",
        "selectFlow": "Изберете поток",
        "selectTriggerNode": "Изберете тригер възел",
        "selectFlowFirst": "Първо изберете поток",
        "addSuccess": "Връзката за събитие е създадена",
        "addError": "Неуспешно създаване на връзката",
        "deleteSuccess": "Връзката е изтрита",
        "deleteError": "Неуспешно изтриване на връзката",
        "enabledSuccess": "Връзката е активирана",
        "disabledSuccess": "Връзката е деактивирана",
        "updateError": "Неуспешно обновяване на връзката",
        "eventDescriptions": {
          "onAppointmentConfirmed": "Задейства се, когато час бъде потвърден от клиента или системата.",
          "onAppointmentCreated": "Задейства се, когато бъде създаден нов час.",
          "onAppointmentRescheduled": "Задейства се, когато съществуващ час бъде преместен в ново време.",
          "onAppointmentRescheduleRequested": "Задейства се, когато клиент изпрати заявка за промяна и часът очаква преглед.",
          "onAppointmentRescheduleRequestRejected": "Задейства се, когато заявка за промяна бъде отхвърлена и часът се върне в предишния си статус.",
          "onAppointmentCancelled": "Задейства се, когато час бъде отменен.",
          "onAppointmentNoShow": "Задейства се, когато час бъде отбелязан като неявяване.",
          "onAppointmentCompleted": "Задейства се, когато час бъде отбелязан като завършен.",
          "onUserRegistered": "Задейства се, когато нов потребител завърши регистрацията си.",
          "onThreadCreated": "Задейства се, когато бъде създадена нова чат или поддръжка нишка.",
          "onThreadArchived": "Задейства се, когато чат или поддръжка нишка бъде архивирана.",
          "onConversationCompleted": "Задейства се, когато разговор по телефон, чат или имейл приключи, заедно с обобщение и маркери за преглед.",
          "onCallFinished": "Задейства се, когато телефонно обаждане приключи.",
          "onLeadCreated": "Задейства се, когато анонимно взаимодействие стане потенциален клиент.",
          "onLeadVerified": "Задейства се, когато потенциален клиент потвърди поне един идентификатор за контакт.",
          "onLeadConverted": "Задейства се, когато потенциален клиент бъде превърнат в клиент или възможност.",
          "onCustomerCreated": "Задейства се, когато бъде създаден нов клиентски запис."
        }
      },
      "backToTenant": "Обратно към клиента"
    },
    "logs": {
      "title": "Логове на тенанта",
      "clientNotFound": "Тенантът не е намерен.",
      "backToTenant": "Назад към {{name}}",
      "clientLogsFor": "Логове – {{name}}",
      "subtitle": "Изпълнения на флоуовете на този тенант и промени по тях."
    },
    "modules": {
      "title": "Управление на модули",
      "backToClient": "Обратно към наемател",
      "managingFor": "Управление на модули за: {{name}}",
      "loadingModules": "Зареждане на модули...",
      "noModulesMatch": "Няма модули, съответстващи на текущите ви филтри",
      "noModulesAvailable": "Няма налични модули",
      "clearAllFilters": "Изчисти всички филтри"
    },
    "empty": "Все още няма клиенти"
  },
  "users": {
    "title": "Управление на потребители",
    "subtitle": "Преглед на потребители и техните членства в наематели.",
    "filters": "Филтри",
    "client": "Клиент",
    "company": "Компания",
    "role": "Роля",
    "allClients": "Всички клиенти",
    "allCompanies": "Всички компании",
    "allRoles": "Всички роли",
    "clearFilters": "Изчисти филтри",
    "search": "Търсене",
    "searchPlaceholder": "по име или имейл",
    "searchPending": "Търсене…",
    "searchResults": "{{count}} потребители за \"{{query}}\"",
    "noSearchResults": "Няма потребители за \"{{query}}\"",
    "paginationTotal": "{{start}}-{{end}} от {{total}} потребители",
    "columns": {
      "user": "Потребител",
      "role": "Роля",
      "tenants": "Тенанти",
      "companies": "Компании",
      "status": "Статус",
      "actions": "Действия"
    },
    "joined": "Присъединен: {{date}}",
    "none": "Няма",
    "more": "+{{count}} още",
    "emailVerified": "Имейл потвърден",
    "emailUnverified": "Имейл непотвърден",
    "phoneVerified": "Телефон потвърден",
    "phoneUnverified": "Телефон непотвърден",
    "view": "Преглед",
    "verification": {
      "resendEmail": "Изпрати отново имейл за потвърждение",
      "markVerified": "Маркирай като потвърден",
      "resendSuccess": "Имейлът за потвърждение е изпратен.",
      "resendError": "Неуспешно изпращане на имейл за потвърждение.",
      "verifySuccess": "Имейлът е маркиран като потвърден.",
      "verifyError": "Неуспешно потвърждаване на имейл.",
      "verifyConfirmTitle": "Маркирай имейла като потвърден?",
      "verifyConfirmDescription": "Това ще позволи на {{name}} да влезе без да кликне върху линка за потвърждение.",
      "verifyConfirmOk": "Маркирай като потвърден",
      "verifyConfirmCancel": "Отказ",
      "unverifiedAlertTitle": "Имейлът не е потвърден",
      "unverifiedAlertDescription": "{{email}} не може да влезе, докато имейлът не е потвърден. Изпратете отново имейла за потвърждение или го маркирайте ръчно като потвърден."
    },
    "create": {
      "button": "Добави потребител",
      "title": "Добавяне на потребител",
      "submit": "Създай потребител",
      "cancel": "Отказ",
      "email": "Имейл",
      "emailRequired": "Имейлът е задължителен",
      "emailInvalid": "Въведете валиден имейл адрес",
      "password": "Парола",
      "passwordRequired": "Паролата е задължителна",
      "passwordMin": "Паролата трябва да е поне 8 символа",
      "passwordHint": "Трябва да съдържа главна и малка буква, цифра и специален символ (@$!%*?&)",
      "name": "Име",
      "nameRequired": "Името е задължително",
      "phone": "Телефон (по избор)",
      "globalRole": "Глобална роля",
      "tenantSectionHint": "По избор: присвояване на наемател и компания. Акаунтът се създава с вече потвърден имейл.",
      "client": "Наемател",
      "clientPlaceholder": "Изберете наемател (по избор)",
      "company": "Компания",
      "companyPlaceholder": "Изберете компания (по избор)",
      "tenantRole": "Роля в наемателя",
      "tenantRoleEmployee": "Служител",
      "tenantRoleOwner": "Собственик",
      "tenantRoleCustomer": "Клиент",
      "success": "Потребителят е създаден успешно.",
      "error": "Неуспешно създаване на потребител: {{error}}"
    },
    "detail": {
      "title": "Детайли за потребител",
      "backToUsers": "Обратно към потребители",
      "errorLoading": "Грешка при зареждане на потребител: {{error}}",
      "subtitle": "Потребителски профил и членства в наематели.",
      "profile": "Профил",
      "globalRole": "Глобална роля",
      "verificationStatus": "Статус на верификация",
      "userId": "Потребителски ID",
      "createdAt": "Създаден на",
      "updatedAt": "Актуализиран на",
      "loading": "Зареждане...",
      "userNotFound": "Потребителят не е намерен.",
      "tenantMemberships": "Членства в наематели",
      "companyMemberships": "Членства в компании",
      "table": {
        "client": "Клиент",
        "role": "Роля",
        "status": "Статус",
        "created": "Създаден",
        "company": "Компания"
      },
      "owner": "Собственик",
      "member": "Член",
      "active": "Активен",
      "inactive": "Неактивен",
      "tenantAccess": {
        "title": "Достъп до тенанти",
        "assign": "Добави към тенант",
        "emptyTitle": "Този потребител все още няма достъп до тенант",
        "emptyDescription": "Добавете тенант, за да му дадете достъп като собственик, служител или клиент.",
        "removeConfirmTitle": "Премахване от {{tenant}}?",
        "removeConfirmDesc": "Потребителят губи достъп до този тенант и всички негови фирми.",
        "removedFromTenant": "Премахнат от {{tenant}}",
        "missingTenantLink": "Достъп до фирма без членство в тенанта.",
        "addTenantLink": "Добави като служител",
        "tenantLinkAdded": "Добавен към тенанта като служител",
        "companyRoleUpdated": "Ролята във фирмата е обновена",
        "removedFromCompany": "Премахнат от фирмата",
        "noCompanies": "Не е добавен към фирма от този тенант.",
        "customerNoCompanies": "Клиентите имат достъп до целия тенант и не се добавят към фирми.",
        "actionError": "Промяната не можа да бъде запазена",
        "assignTitle": "Добавяне към тенант",
        "assignSubmit": "Добави",
        "assignDescription": "Дайте на {{name}} достъп до тенант и по желание до някои от фирмите му.",
        "tenant": "Тенант",
        "tenantRequired": "Моля, изберете тенант",
        "tenantRole": "Роля в тенанта",
        "companies": "Фирми",
        "companiesHint": "По желание. Собствениците и служителите могат да бъдат добавени към фирми и по-късно.",
        "companyRole": "Роля във фирмата",
        "assigned": "Добавен към {{tenant}}",
        "assignPartial": "Добавен към {{tenant}}, но добавянето към тези фирми е неуспешно: {{companies}}",
        "assignError": "Неуспешно добавяне към тенант",
        "staffTitle": "Администраторите и разработчиците не се добавят към тенанти",
        "staffDescription": "Глобалната им роля вече им дава достъп до всички тенанти.",
        "staffKeptNote": "Запазени от преди потребителят да стане администратор/разработчик. В момента нямат ефект (глобалната роля вече дава достъп до всички тенанти) и важат отново, ако потребителят бъде понижен."
      }
    },
    "empty": "Няма намерени потребители",
    "roleOptions": {
      "ADMIN": "Администратор",
      "DEVELOPER": "Разработчик",
      "USER": "Потребител",
      "CUSTOMER": "Клиент"
    },
    "searchByNameOrEmail": "Търсене по име или имейл"
  },
  "roles": {
    "admin": "Администратор",
    "user": "Потребител",
    "customer": "Клиент"
  },
  "roleEditor": {
    "cannotChangeOwnRole": "Не можете да промените собствената си роля",
    "editTooltip": "Кликнете, за да редактирате ролята на потребителя",
    "changeTitle": "Промяна на роля на потребител",
    "saveChanges": "Запази промените",
    "cancel": "Отказ",
    "editingFor": "Редактиране на роля за:",
    "selectNewRole": "Изберете нова роля:",
    "current": "Текуща",
    "confirmTitle": "Потвърждение за промяна на роля",
    "confirmDescription": "На път сте да промените ролята на потребителя на <strong>{{role}}</strong>.",
    "selectRole": "Моля, изберете роля",
    "noChanges": "Няма направени промени",
    "updateSuccess": "Ролята на потребителя е актуализирана успешно",
    "updateError": "Неуспешна актуализация на ролята на потребителя"
  },
  "modules": {
    "searchPlaceholder": "Търсене на модули по име, ID, описание, автор или категория...",
    "all": "Всички ({{count}})",
    "enabled": "Активирани ({{count}})",
    "disabled": "Деактивирани ({{count}})",
    "filterByCategory": "Филтриране по категория:",
    "allCategories": "Всички категории",
    "columns": {
      "module": "Модул",
      "id": "ID",
      "requiredRoles": "Изисквани роли",
      "configuration": "Конфигурация",
      "actions": "Действия"
    },
    "enabledStatus": "Активиран",
    "disabledStatus": "Деактивиран",
    "none": "Няма",
    "configRequired": "Необходима е конфигурация за активиране",
    "required": "Задължително",
    "notConfigured": "Не е конфигуриран",
    "incomplete": "Непълна",
    "missing": "Липсващи: {{fields}}",
    "complete": "Пълна",
    "fullyConfigured": "Напълно конфигуриран",
    "default": "По подразбиране",
    "configureModule": "Конфигуриране на модул",
    "configureToEnable": "Конфигурирайте за активиране",
    "totalModules": "Общо {{count}} модула",
    "enableModal": {
      "title": "Активиране на модул: {{name}}",
      "okText": "Активирай модул",
      "cancel": "Отказ",
      "configRequired": "Необходима е конфигурация",
      "configRequiredDesc": "Моля, попълнете всички задължителни полета, за да активирате този модул.",
      "noConfigRequired": "Не е необходима конфигурация",
      "noConfigRequiredDesc": "Този модул може да бъде активиран без допълнителна конфигурация."
    },
    "configModal": {
      "title": "Конфигуриране на модул: {{name}}",
      "okText": "Запази конфигурация",
      "cancel": "Отказ",
      "moduleId": "ID на модул",
      "version": "Версия",
      "author": "Автор",
      "description": "Описание",
      "noDescription": "Без описание",
      "na": "Н/Д",
      "noSchema": "Няма конфигурационна схема",
      "noSchemaDesc": "Този модул няма дефинирана конфигурационна схема.",
      "saveError": "Неуспешно запазване на конфигурацията"
    }
  },
  "conversationOverview": {
    "title": "Преглед на разговори между тенанти",
    "description": "Активност на разговори във всички тенанти, за да се забелязват проблеми без отваряне на всеки тенант.",
    "level1Title": "Обобщение по тенант",
    "level2Title": "Подробни разговори",
    "yes": "Да",
    "no": "Не",
    "transferred": "Прехвърлен към служител",
    "loadError": "Неуспешно зареждане на данните за преглед на разговори.",
    "emptyTenants": "Няма намерени тенанти.",
    "emptyConversations": "Няма разговори за избраните филтри.",
    "paginationTotal": "{{start}}-{{end}} от {{total}} разговора",
    "periods": {
      "today": "Днес",
      "7d": "Последните 7 дни",
      "30d": "Последните 30 дни",
      "custom": "По избор"
    },
    "filters": {
      "tenant": "Тенант",
      "channel": "Канал",
      "flag": "Флаг",
      "humanHandoff": "Human Handoff",
      "technicalIssue": "Технически проблем",
      "clearAll": "Изчисти филтрите"
    },
    "columns": {
      "tenant": "Тенант",
      "total": "Общо разговори",
      "technicalIssue": "Технически проблем",
      "humanHandoff": "Human Handoff",
      "flaggedRed": "Червен флаг",
      "channel": "Канал",
      "startedAt": "Дата и час",
      "duration": "Продължителност",
      "customerHelped": "Клиентът е помогнат",
      "delay": "Закъснение",
      "callbackRequested": "Заявен обратен разговор",
      "flag": "Флаг",
      "summary": "Обобщение",
      "actions": "Действия"
    },
    "channel": {
      "call": "Обаждане",
      "chat": "Чат",
      "email": "Имейл"
    },
    "flag": {
      "green": "Зелен",
      "red": "Червен"
    },
    "duration": {
      "seconds": "{{seconds}}с",
      "minutesSeconds": "{{minutes}}м {{seconds}}с",
      "hoursMinutes": "{{hours}}ч {{minutes}}м",
      "veryShort": "много кратко",
      "veryLong": "много дълго"
    },
    "details": "Детайли",
    "detail": {
      "back": "Обратно към прегледа",
      "notFound": "Разговорът не е намерен",
      "notFoundDescription": "Тази нишка липсва или вече не е налична.",
      "openFlow": "Отвори потока",
      "copyThreadId": "Копирай ID на нишката",
      "copyCallId": "Копирай ID на обаждането",
      "copied": "Копирано",
      "completion": "Завършване",
      "identifiers": "Идентификатори",
      "voice": "Обаждане",
      "summary": "Обобщение",
      "started": "Започнал",
      "ended": "Приключил",
      "customerHelped": "Клиентът е помогнат",
      "technicalIssues": "Причини за техническия проблем",
      "contact": "Контакт",
      "threadId": "ID на нишката",
      "client": "Тенант",
      "companyId": "ID на компания",
      "flowId": "ID на потока",
      "callId": "ID на обаждането",
      "sessionId": "ID на сесия",
      "userId": "ID на потребител",
      "status": "Статус",
      "fromNumber": "От",
      "toNumber": "До",
      "callStatus": "Статус на обаждането",
      "endReason": "Причина за край",
      "endCode": "Код за край",
      "provider": "Доставчик",
      "engine": "Двигател",
      "transport": "Транспорт",
      "noFlow": "Няма назначен поток",
      "internalContext": "Вътрешен контекст",
      "contextSummary": "Обобщение на контекста",
      "voiceContext": "Контекст за завършване на обаждането",
      "redFlagAlert": "Този разговор е с червен флаг.",
      "technicalIssueAlert": "За този разговор е записан технически проблем.",
      "turn": "Ход {{index}}",
      "openExecution": "Отвори изпълнението",
      "noExecution": "Няма изпълнение на потока",
      "copyCorrelationId": "Копирай correlation ID",
      "truncatedMessages": "Транскриптът може да е непълен. Заредени са само последните 1000 съобщения.",
      "truncatedExecutions": "Някои изпълнения на потока не са заредени. Съответните ходове може да нямат изпълнение.",
      "emailSummaryOnly": "Този имейл разговор е показан с обобщението си. Текстът на писмата не е достъпен на тази страница.",
      "noData": "—",
      "active": "Активен",
      "archived": "Архивиран"
    }
  },
  "tenantPickers": {
    "tenantPlaceholder": "Изберете тенант",
    "noTenants": "Няма налични тенанти",
    "companyPlaceholder": "Изберете фирми",
    "noCompanies": "Този тенант няма фирми"
  },
  "logs": {
    "view": "Преглед",
    "pagination": "{{start}}–{{end}} от {{total}}",
    "emptyHint": "Изберете по-дълъг период или изчистете филтрите.",
    "refresh": "Обнови",
    "export": "Експорт в CSV",
    "lastUpdated": "Обновено {{time}}",
    "status": {
      "STARTED": "Изпълнява се",
      "COMPLETED": "Завършено",
      "FAILED": "Неуспешно"
    },
    "tabs": {
      "executions": "Изпълнения на флоуове",
      "audit": "Журнал на промените"
    },
    "kpi": {
      "total": "Изпълнения",
      "completed": "Завършени",
      "failed": "Неуспешни",
      "running": "Изпълняват се"
    },
    "filters": {
      "allTenants": "Всички тенанти",
      "allStatuses": "Всички статуси",
      "searchAudit": "Търсене по потребител, действие или обект",
      "clear": "Изчисти филтрите",
      "tenantLevel": "Ниво тенант",
      "company": "Фирма: {{name}}"
    },
    "executions": {
      "columns": {
        "time": "Време",
        "status": "Статус",
        "tenant": "Тенант",
        "flow": "Флоу",
        "duration": "Продължителност",
        "error": "Грешка",
        "correlationId": "Correlation ID"
      },
      "empty": "Няма изпълнения на флоуове в този период",
      "failedInNode": "Грешка в нод {{node}}"
    },
    "audit": {
      "columns": {
        "time": "Време",
        "user": "Потребител",
        "action": "Действие",
        "entity": "ID на обекта"
      },
      "empty": "Няма записи в журнала за този период",
      "emptyHint": "Записват се само създаване и промяна на флоуове и шаблони.",
      "actions": {
        "FLOW_CREATED": "Създаден флоу",
        "FLOW_UPDATED": "Променен флоу",
        "TEMPLATE_CREATED": "Създаден шаблон",
        "TEMPLATE_UPDATED": "Променен шаблон"
      }
    },
    "drawer": {
      "title": "Изпълнение на флоу",
      "openInBackstage": "Отвори в Backstage",
      "startedAt": "Стартирано",
      "duration": "Продължителност",
      "tenant": "Тенант",
      "template": "Шаблон",
      "triggeredBy": "Стартирано от",
      "executionId": "ID на изпълнението",
      "correlationId": "Correlation ID",
      "userId": "ID на потребителя",
      "conversation": "Разговор",
      "openConversation": "Отвори разговора",
      "steps": "Стъпки",
      "noSteps": "Няма записани стъпки за това изпълнение",
      "triggerData": "Данни от тригера",
      "timings": "Времена",
      "failedNode": "Нод с грешка"
    }
  }
}
